/* Night Flow quiz controller (theme version). Same interaction model as the UltimaPeak quiz funnel v2:
   single choice advances after 350 ms, multi choice reveals Continue, history-based back button,
   three-phase loading with a yes/no modal per phase, Submit opens the product page with attribution.
   Steps are the .step elements in DOM order (one theme-editor block each), so they can be reordered,
   added or removed in the editor. In the editor, selecting a block shows that step. */
(function () {
  'use strict';
  var MAP16 = [6, 12, 18, 24, 30, 36, 42, 50, 56, 62, 68, 74, 80, 86, 92, 100];

  function Quiz(root) {
    var self = this;
    this.root = root;
    this.steps = [].slice.call(root.querySelectorAll('.step'));
    this.bar = root.querySelector('.progress-bar-fill');
    this.back = root.querySelector('.back-btn');
    this.modal = root.querySelector('.modal-overlay');
    this.modalText = root.querySelector('.modal-text');
    this.productUrl = root.getAttribute('data-product-url') || '/products/gut-relief';
    this.current = 0; this.history = [0]; this.timers = []; this.phase = 0; this.loading = null;
    root.addEventListener('click', function (e) { self.onClick(e); });
    this.show(0, true);
  }
  Quiz.prototype.progress = function (i) {
    var n = this.steps.length;
    if (n === 16) return MAP16[i];
    if (n === 17) return i < 16 ? MAP16[i] : 100; // 16 original steps + result screen
    if (n < 2) return 100;
    return Math.round(6 + 94 * i / (n - 1));
  };
  Quiz.prototype.later = function (fn, ms) { this.timers.push(setTimeout(fn, ms)); };
  Quiz.prototype.clearTimers = function () { for (var i = 0; i < this.timers.length; i++) clearTimeout(this.timers[i]); this.timers = []; };
  Quiz.prototype.show = function (i, initial) {
    if (i < 0 || i >= this.steps.length) return;
    for (var k = 0; k < this.steps.length; k++) this.steps[k].classList.toggle('active', k === i);
    this.current = i;
    if (this.bar) this.bar.style.width = this.progress(i) + '%';
    if (this.back) this.back.style.display = i > 0 ? 'block' : 'none';
    if (!initial) window.scrollTo({ top: 0, behavior: 'smooth' });
    this.clearTimers();
    this.closeModal(true);
    if (this.steps[i].getAttribute('data-kind') === 'loading') this.startLoading(this.steps[i]);
  };
  Quiz.prototype.go = function (i) { this.history.push(i); this.show(i); };
  Quiz.prototype.goBack = function () {
    if (this.history.length > 1) { this.history.pop(); this.show(this.history[this.history.length - 1]); }
  };
  function select(el, selector) {
    var all = el.parentElement.querySelectorAll(selector);
    for (var i = 0; i < all.length; i++) all[i].classList.remove('selected');
    el.classList.add('selected');
  }
  Quiz.prototype.onClick = function (e) {
    var t = e.target, self = this;
    if (!t.closest) return;
    if (t.closest('a[data-product-link]')) return; // result CTA: plain link, attribution set by nf-shared.js
    if (t.closest('.back-btn')) { this.goBack(); return; }
    if (t.closest('.modal-btn')) { this.closeModal(false); return; }
    if (t.closest('[data-submit]')) { if (this.current + 1 < this.steps.length) this.go(this.current + 1); else this.submit(); return; }
    var step = t.closest('.step');
    if (!step || step !== this.steps[this.current]) return;
    if (t.closest('.continue-btn')) { this.go(this.current + 1); return; }
    var card = t.closest('.age-card');
    if (card) { select(card, '.age-card'); this.later(function () { self.go(self.current + 1); }, 350); return; }
    var opt = t.closest('.option-item');
    if (!opt) return;
    if (step.getAttribute('data-kind') === 'multi') {
      opt.classList.toggle('selected');
      var btn = step.querySelector('.continue-btn');
      if (btn) btn.classList.toggle('visible', !!step.querySelector('.option-item.selected'));
    } else {
      select(opt, '.option-item');
      this.later(function () { self.go(self.current + 1); }, 350);
    }
  };
  Quiz.prototype.startLoading = function (step) {
    this.phase = 0; this.loading = step;
    var submit = step.querySelector('[data-submit]'); if (submit) submit.classList.remove('visible');
    var items = step.querySelectorAll('.loading-step-item');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.remove('visible');
      items[i].querySelector('.loading-item-bar-fill').style.width = '0%';
      var st = items[i].querySelector('.loading-step-status'); st.textContent = ''; st.className = 'loading-step-status';
    }
    this.runPhase();
  };
  Quiz.prototype.runPhase = function () {
    var self = this, items = this.loading.querySelectorAll('.loading-step-item');
    if (this.phase >= items.length) { var s = this.loading.querySelector('[data-submit]'); if (s) s.classList.add('visible'); return; }
    var it = items[this.phase];
    it.classList.add('visible');
    this.later(function () { it.querySelector('.loading-item-bar-fill').style.width = '50%'; it.querySelector('.loading-step-status').textContent = '50%'; }, 100);
    this.later(function () { self.openModal(it.getAttribute('data-modal') || ''); }, 1500);
  };
  Quiz.prototype.openModal = function (text) { if (!this.modal) return; this.modalText.textContent = text; this.modal.classList.add('active'); };
  Quiz.prototype.closeModal = function (silent) {
    if (!this.modal) return;
    var wasOpen = this.modal.classList.contains('active');
    this.modal.classList.remove('active');
    if (silent || !wasOpen || !this.loading) return;
    var self = this, it = this.loading.querySelectorAll('.loading-step-item')[this.phase];
    if (!it) return;
    this.later(function () { it.querySelector('.loading-item-bar-fill').style.width = '100%'; it.querySelector('.loading-step-status').textContent = '100%'; }, 100);
    this.later(function () { var st = it.querySelector('.loading-step-status'); st.textContent = '✓'; st.className = 'loading-step-status loading-step-check'; }, 1500);
    this.later(function () { self.phase++; self.runPhase(); }, 1900);
  };
  Quiz.prototype.submit = function () {
    var url = window.NF_SHARED ? window.NF_SHARED.productUrl(window.location.search, 'quiz', this.productUrl) : this.productUrl;
    document.dispatchEvent(new CustomEvent('nightflow:funnel', { detail: { funnel: 'quiz', action: 'product_click' } }));
    window.location.href = url;
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-nf-quiz]');
    for (var i = 0; i < roots.length; i++) if (!roots[i].nfQuiz) roots[i].nfQuiz = new Quiz(roots[i]);
  }
  init();
  window.NF_QUIZ_INIT = init;
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var step = e.target && e.target.closest ? e.target.closest('.step') : null;
      var root = step ? step.closest('[data-nf-quiz]') : null;
      if (root && root.nfQuiz) { var i = root.nfQuiz.steps.indexOf(step); if (i >= 0) { root.nfQuiz.history = [0]; root.nfQuiz.show(i, true); } }
    });
  }
})();
